import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "navbar z-index-999"
}
const _hoisted_2 = { class: "navbar-content" }
const _hoisted_3 = { class: "row w-100" }
const _hoisted_4 = { class: "col-md-10" }
const _hoisted_5 = { class: "input-search-by-matricule w-100" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "navbar-nav" }
const _hoisted_8 = {
  class: "nav-link dropdown-toggle",
  href: "javascript:void(0);"
}
const _hoisted_9 = { class: "alert-numbers" }
const _hoisted_10 = { class: "nav-item dropdown" }
const _hoisted_11 = { class: "alert-numbers" }
const _hoisted_12 = { class: "alert-numbers" }
const _hoisted_13 = {
  class: "nav-link dropdown-toggle",
  href: "javascript:void(0);"
}
const _hoisted_14 = { class: "alert-numbers" }
const _hoisted_15 = {
  class: "nav-link dropdown-toggle",
  href: "javascript:void(0);"
}
const _hoisted_16 = { class: "alert-numbers" }
const _hoisted_17 = {
  class: "nav-link dropdown-toggle",
  href: "javascript:void(0);"
}
const _hoisted_18 = { class: "alert-numbers" }
const _hoisted_19 = {
  class: "nav-link dropdown-toggle",
  href: "javascript:void(0);"
}
const _hoisted_20 = { class: "alert-numbers" }
const _hoisted_21 = {
  key: 5,
  class: "nav-item dropdown alerts"
}
const _hoisted_22 = {
  class: "nav-link dropdown-toggle",
  href: "javascript:void(0);",
  id: "profileDropdowns",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_23 = { class: "alert-numbers" }
const _hoisted_24 = {
  class: "dropdown-menu",
  "aria-labelledby": "profileDropdowns"
}
const _hoisted_25 = { class: "d-flex justify-content-between dropdown-title" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "d-flex align-items-center justify-content-center item" }
const _hoisted_29 = { class: "preview-thumbnail" }
const _hoisted_30 = { class: "alert-item-content flex-grow ms-2" }
const _hoisted_31 = { class: "preview-subject ellipsis font-weight-medium text-dark" }
const _hoisted_32 = { class: "preview-subject ellipsis font-weight-medium text-dark" }
const _hoisted_33 = { class: "ms-2" }
const _hoisted_34 = { class: "font-weight-light small-text" }
const _hoisted_35 = { style: {"font-weight":"bold !important"} }
const _hoisted_36 = { class: "ms-2" }
const _hoisted_37 = { style: {"font-weight":"bold !important"} }
const _hoisted_38 = {
  key: 1,
  class: "alert-items"
}
const _hoisted_39 = {
  key: 6,
  class: "nav-item dropdown alerts"
}
const _hoisted_40 = {
  class: "nav-link dropdown-toggle",
  href: "javascript:void(0);",
  id: "profileDropdowns",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_41 = { class: "alert-numbers" }
const _hoisted_42 = {
  class: "dropdown-menu",
  "aria-labelledby": "profileDropdowns"
}
const _hoisted_43 = { class: "d-flex justify-content-between dropdown-title" }
const _hoisted_44 = { class: "" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "d-flex align-items-center justify-content-center item" }
const _hoisted_47 = { class: "preview-thumbnail" }
const _hoisted_48 = { class: "alert-item-content flex-grow ms-2" }
const _hoisted_49 = { class: "preview-subject ellipsis font-weight-medium text-dark" }
const _hoisted_50 = { class: "preview-subject ellipsis font-weight-medium text-dark" }
const _hoisted_51 = { class: "ms-2" }
const _hoisted_52 = { class: "font-weight-light small-text" }
const _hoisted_53 = { style: {"font-weight":"bold !important"} }
const _hoisted_54 = { class: "ms-2" }
const _hoisted_55 = { style: {"font-weight":"bold !important"} }
const _hoisted_56 = {
  key: 1,
  class: "alert-items"
}
const _hoisted_57 = {
  key: 7,
  class: "nav-item dropdown alerts"
}
const _hoisted_58 = {
  class: "nav-link dropdown-toggle",
  href: "javascript:void(0);",
  id: "profileDropdowns",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_59 = { class: "alert-numbers" }
const _hoisted_60 = {
  class: "dropdown-menu",
  "aria-labelledby": "profileDropdowns"
}
const _hoisted_61 = { class: "d-flex justify-content-between dropdown-title" }
const _hoisted_62 = { class: "" }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "d-flex align-items-center justify-content-center item" }
const _hoisted_65 = { class: "preview-thumbnail" }
const _hoisted_66 = { class: "alert-item-content flex-grow ms-2" }
const _hoisted_67 = { class: "preview-subject ellipsis font-weight-medium text-dark" }
const _hoisted_68 = { class: "ms-2" }
const _hoisted_69 = { class: "font-weight-light small-text" }
const _hoisted_70 = { style: {"font-weight":"bold !important"} }
const _hoisted_71 = { class: "ms-2" }
const _hoisted_72 = { style: {"font-weight":"bold !important"} }
const _hoisted_73 = {
  key: 1,
  class: "alert-items"
}
const _hoisted_74 = { class: "nav-item dropdown langs" }
const _hoisted_75 = {
  class: "nav-link dropdown-toggle",
  href: "javascript:void(0);",
  id: "profileDropdown",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_76 = { class: "alert-numbers lang" }
const _hoisted_77 = {
  class: "dropdown-menu",
  "aria-labelledby": "profileDropdown"
}
const _hoisted_78 = { class: "list-unstyled" }
const _hoisted_79 = ["onClick"]
const _hoisted_80 = { class: "symbole-lang" }
const _hoisted_81 = { class: "nav-item dropdown" }
const _hoisted_82 = {
  class: "nav-link dropdown-toggle",
  href: "javascript:void(0);",
  id: "profileDropdown",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_83 = {
  class: "dropdown-menu",
  "aria-labelledby": "profileDropdown"
}
const _hoisted_84 = { class: "d-flex flex-column align-items-center bcustom-alert-bottom px-5 py-1 border-bottom" }
const _hoisted_85 = { class: "text-left" }
const _hoisted_86 = { class: "tx-16 text-uppercase" }
const _hoisted_87 = { class: "text-center" }
const _hoisted_88 = { class: "tx-16" }
const _hoisted_89 = { class: "tx-16" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("b", null, "ID : ", -1)
const _hoisted_91 = { class: "list-unstyled" }
const _hoisted_92 = {
  key: 0,
  class: "dropdown-item cursor-pointer border-bottom"
}
const _hoisted_93 = { class: "bg-none text-body py-1 d-block w-100" }
const _hoisted_94 = { class: "link-title" }
const _hoisted_95 = { class: "dropdown-item cursor-pointer border-bottom" }
const _hoisted_96 = { class: "dropdown-item cursor-pointer border-bottom" }
const _hoisted_97 = { class: "bg-none text-body py-1 d-block w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_browser = _resolveComponent("modal-browser")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_element_tooltip = _resolveComponent("element-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_path_image = _resolveComponent("path-image")!
  const _component_not_found = _resolveComponent("not-found")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_modal_browser, { fiche_member: _ctx.fiche_member }, null, 8, ["fiche_member"]),
    (_ctx.userUUID)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
          _createElementVNode("a", {
            class: _normalizeClass(["sidebar-toggler cursor-pointer", _ctx.isTogglerActive ? 'active' : 'not-active']),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: "bars",
              size: "lg"
            })
          ], 2),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("input", {
                    style: {"margin-top":"10px"},
                    placeholder: _ctx.i18n.t('layout.navbar.form.search_member'),
                    class: "form-control w-100",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchBy.cin) = $event)),
                    onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.searchMemberByCIN && _ctx.searchMemberByCIN(...args)), ["enter"]))
                  }, null, 40, _hoisted_6), [
                    [_vModelText, _ctx.searchBy.cin]
                  ])
                ])
              ])
            ]),
            _createElementVNode("ul", _hoisted_7, [
              (_ctx.hasPermission('display_monitor_static') || _ctx.hasPermission('display_monitor_multi'))
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    class: "nav-item dropdown cursor-pointer",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openTvMonitor && _ctx.openTvMonitor(...args)))
                  }, [
                    _createElementVNode("a", _hoisted_8, [
                      _createVNode(_component_element_tooltip, {
                        text: _ctx.i18n.t('layout.navbar.alerts.tv.display_monitor'),
                        position: "left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_9, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "tv",
                              size: "lg",
                              class: "link-icon"
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_10, [
                (_ctx.reloadQrCodeScan)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.reloadQrCodeScan = !_ctx.reloadQrCodeScan)),
                      class: "nav-link dropdown-toggle",
                      href: "javascript:void(0);"
                    }, [
                      _createVNode(_component_element_tooltip, {
                        text: _ctx.i18n.t('layout.navbar.alerts.camera.active'),
                        position: "left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_11, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: 'video-camera',
                              size: "lg",
                              class: "link-icon",
                              style: {"color":"#279d54"}
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ]))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.reloadQrCodeScan = !_ctx.reloadQrCodeScan)),
                      class: "nav-link dropdown-toggle",
                      href: "javascript:void(0);"
                    }, [
                      _createVNode(_component_element_tooltip, {
                        text: _ctx.i18n.t('layout.navbar.alerts.camera.inactif'),
                        position: "left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_12, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: !_ctx.reloadQrCodeScan ? 'video-slash' : 'video',
                              size: "lg",
                              class: "link-icon"
                            }, null, 8, ["icon"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ]))
              ]),
              (_ctx.hasPermission('create_stock_orders'))
                ? (_openBlock(), _createElementBlock("li", {
                    key: 1,
                    class: "nav-item dropdown cursor-pointer",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.redirectTo({ name: 'stock-add-order', params: { clubUUID: _ctx.clubUUID } })))
                  }, [
                    _createElementVNode("a", _hoisted_13, [
                      _createVNode(_component_element_tooltip, {
                        text: _ctx.i18n.t('layout.sidbar.stock.sales.add_order_product'),
                        position: "left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_14, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "cart-plus",
                              size: "lg",
                              class: "link-icon"
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasPermission('create_stock_orders'))
                ? (_openBlock(), _createElementBlock("li", {
                    key: 2,
                    class: "nav-item dropdown cursor-pointer",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.redirectTo({ name: 'stock-add-order-spa', params: { clubUUID: _ctx.clubUUID } })))
                  }, [
                    _createElementVNode("a", _hoisted_15, [
                      _createVNode(_component_element_tooltip, {
                        text: _ctx.i18n.t('layout.sidbar.stock.sales.add_order_service'),
                        position: "left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_16, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "spa",
                              size: "lg",
                              class: "link-icon"
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasPermission('new_subscriptions'))
                ? (_openBlock(), _createElementBlock("li", {
                    key: 3,
                    class: "nav-item dropdown cursor-pointer",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.redirectTo({ name: 'inscription', params: { clubUUID: _ctx.clubUUID } })))
                  }, [
                    _createElementVNode("a", _hoisted_17, [
                      _createVNode(_component_element_tooltip, {
                        text: _ctx.i18n.t('layout.sidbar.subscriptions.new_subscriptions'),
                        position: "left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_18, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "user-plus",
                              size: "lg",
                              class: "link-icon"
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasPermission('credits'))
                ? (_openBlock(), _createElementBlock("li", {
                    key: 4,
                    class: "nav-item dropdown cursor-pointer",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.redirectTo({ name: 'credits', params: { clubUUID: _ctx.clubUUID } })))
                  }, [
                    _createElementVNode("a", _hoisted_19, [
                      _createVNode(_component_element_tooltip, {
                        text: _ctx.i18n.t('layout.sidbar.regulations.credits'),
                        position: "left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_20, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "hand-holding-dollar",
                              size: "lg",
                              class: "link-icon"
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasPermission('transactions'))
                ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                    _createElementVNode("a", _hoisted_22, [
                      _createVNode(_component_element_tooltip, {
                        text: _ctx.i18n.t('layout.navbar.alerts.payment_due_date.title'),
                        position: "left"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "calendar-alt",
                            size: "lg",
                            class: "link-icon"
                          }),
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.transactions_due_dateCount), 1)
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.i18n.t('layout.navbar.alerts.payment_due_date.title')), 1),
                        (_ctx.hasPermission('transactions'))
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'encaissements', params: { clubUUID: _ctx.clubUUID }, query: { paymentMethod: 'Chèque bancaire' } },
                              class: "bg-none ms-3"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.i18n.t('button.display_all')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.transactions_due_dateList?.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions_due_dateList, (transaction, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "alert-items",
                                key: `${transaction.id}-${index}`
                              }, [
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _createVNode(_component_path_image, {
                                      class: "img-table",
                                      path_image: transaction?.member?.path_image
                                    }, null, 8, ["path_image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("p", _hoisted_31, [
                                      _createElementVNode("b", null, [
                                        _createElementVNode("p", _hoisted_32, [
                                          _createElementVNode("b", null, [
                                            (transaction?.member?.uuid)
                                              ? (_openBlock(), _createBlock(_component_router_link, {
                                                  key: 0,
                                                  class: "bg-none",
                                                  to: { name: 'fiche', params: { clubUUID: _ctx.clubUUID, memberUUID: transaction?.member?.uuid } }
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("span", null, _toDisplayString(transaction?.member?.matricule) + ", ", 1),
                                                    _createElementVNode("span", _hoisted_33, _toDisplayString(transaction?.member?.name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["to"]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("p", _hoisted_34, [
                                      _createElementVNode("span", null, [
                                        _createElementVNode("b", _hoisted_35, _toDisplayString(_ctx.i18n.t('tables.payment.chequeNum')) + " : ", 1),
                                        _createTextVNode(" " + _toDisplayString(transaction?.chequeNum), 1)
                                      ]),
                                      _createElementVNode("span", _hoisted_36, [
                                        _createElementVNode("b", _hoisted_37, _toDisplayString(_ctx.i18n.t('tables.payment.dueDate')) + " :", 1),
                                        _createTextVNode(" " + _toDisplayString(_ctx.formatDate(transaction?.dueDate)), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createVNode(_component_not_found, {
                              text: _ctx.i18n.t('message.data_not_found.title'),
                              icon: "warning"
                            }, null, 8, ["text"])
                          ]))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasPermission('expired_subscriptions'))
                ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                    _createElementVNode("a", _hoisted_40, [
                      _createVNode(_component_element_tooltip, {
                        text: _ctx.i18n.t('layout.navbar.alerts.expired_subscriptions.title'),
                        position: "left"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "hourglass-end",
                            size: "lg",
                            class: "link-icon"
                          }),
                          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.expired_subscriptionsCount), 1)
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.i18n.t('layout.navbar.alerts.expired_subscriptions.title')), 1),
                        (_ctx.hasPermission('expired_subscriptions'))
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'expired-subscriptions', params: { clubUUID: _ctx.clubUUID } },
                              class: "bg-none ms-3"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.i18n.t('button.display_all')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.expired_subscriptionsList?.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expired_subscriptionsList, (subscription, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "alert-items",
                                key: `${subscription.id}-${index}`
                              }, [
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("div", _hoisted_47, [
                                    _createVNode(_component_path_image, {
                                      class: "img-table",
                                      path_image: subscription?.member_info?.path_image
                                    }, null, 8, ["path_image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("p", _hoisted_49, [
                                      _createElementVNode("b", null, [
                                        _createElementVNode("p", _hoisted_50, [
                                          _createElementVNode("b", null, [
                                            (subscription?.member_info?.uuid)
                                              ? (_openBlock(), _createBlock(_component_router_link, {
                                                  key: 0,
                                                  class: "bg-none",
                                                  to: { name: 'fiche', params: { clubUUID: _ctx.clubUUID, memberUUID: subscription?.member_info?.uuid } }
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("span", null, _toDisplayString(subscription?.member_info?.matricule) + ", ", 1),
                                                    _createElementVNode("span", _hoisted_51, _toDisplayString(subscription?.member_info?.name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["to"]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("p", _hoisted_52, [
                                      _createElementVNode("span", null, [
                                        _createElementVNode("b", _hoisted_53, _toDisplayString(_ctx.i18n.t('tables.subscription_member.end_date')) + " : ", 1),
                                        _createTextVNode(" " + _toDisplayString(_ctx.formatDate(subscription?.end_date)), 1)
                                      ]),
                                      _createElementVNode("span", _hoisted_54, [
                                        _createElementVNode("b", _hoisted_55, _toDisplayString(_ctx.i18n.t('tables.subscription_member.remaining_days')) + " :", 1),
                                        _createTextVNode(" " + _toDisplayString(subscription?.status?.remaining_days) + " " + _toDisplayString(_ctx.i18n.t('symbole.day')), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                            _createVNode(_component_not_found, {
                              text: _ctx.i18n.t('message.data_not_found.title'),
                              icon: "warning"
                            }, null, 8, ["text"])
                          ]))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasPermission('subscriptions_expiring'))
                ? (_openBlock(), _createElementBlock("li", _hoisted_57, [
                    _createElementVNode("a", _hoisted_58, [
                      _createVNode(_component_element_tooltip, {
                        text: _ctx.i18n.t('layout.navbar.alerts.subscriptions_expiring.title'),
                        position: "left"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "hourglass-half",
                            size: "lg",
                            class: "link-icon"
                          }),
                          _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.subscriptions_expiringCount), 1)
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.i18n.t('layout.navbar.alerts.subscriptions_expiring.title')), 1),
                        (_ctx.hasPermission('subscriptions_expiring'))
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { name: 'subscriptions-expiring', params: { clubUUID: _ctx.clubUUID } },
                              class: "bg-none ms-3"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.i18n.t('button.display_all')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.subscriptions_expiringList?.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscriptions_expiringList, (subscription, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "alert-items",
                                key: `${subscription.id}-${index}`
                              }, [
                                _createElementVNode("div", _hoisted_64, [
                                  _createElementVNode("div", _hoisted_65, [
                                    _createVNode(_component_path_image, {
                                      class: "img-table",
                                      path_image: subscription?.member_info?.path_image
                                    }, null, 8, ["path_image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_66, [
                                    _createElementVNode("p", _hoisted_67, [
                                      _createElementVNode("b", null, [
                                        (subscription?.member_info?.uuid)
                                          ? (_openBlock(), _createBlock(_component_router_link, {
                                              key: 0,
                                              class: "bg-none",
                                              to: { name: 'fiche', params: { clubUUID: _ctx.clubUUID, memberUUID: subscription?.member_info?.uuid } }
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(subscription?.member_info?.matricule) + ", ", 1),
                                                _createElementVNode("span", _hoisted_68, _toDisplayString(subscription?.member_info?.name), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["to"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("p", _hoisted_69, [
                                      _createElementVNode("span", null, [
                                        _createElementVNode("b", _hoisted_70, _toDisplayString(_ctx.i18n.t('tables.subscription_member.end_date')) + " : ", 1),
                                        _createTextVNode(" " + _toDisplayString(_ctx.formatDate(subscription?.end_date)), 1)
                                      ]),
                                      _createElementVNode("span", _hoisted_71, [
                                        _createElementVNode("b", _hoisted_72, _toDisplayString(_ctx.i18n.t('tables.subscription_member.remaining_days')) + " :", 1),
                                        _createTextVNode(" " + _toDisplayString(subscription?.status?.remaining_days) + " " + _toDisplayString(_ctx.i18n.t('symbole.day')), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_73, [
                            _createVNode(_component_not_found, {
                              text: _ctx.i18n.t('message.data_not_found.title'),
                              icon: "warning"
                            }, null, 8, ["text"])
                          ]))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_74, [
                _createElementVNode("a", _hoisted_75, [
                  _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.selectedLang), 1)
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("ul", _hoisted_78, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langs, (lang, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass(["dropdown-item d-flex cursor-pointer lang-item", { 'active-lang': _ctx.selectedLang == lang }]),
                        onClick: ($event: any) => (_ctx.changeLanguage(lang)),
                        key: index
                      }, [
                        _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.i18n.t('lang.' + lang + '.symbole')), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.i18n.t('lang.' + lang + '.title')), 1)
                      ], 10, _hoisted_79))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("li", _hoisted_81, [
                _createElementVNode("a", _hoisted_82, [
                  _createVNode(_component_path_image, {
                    class: "wd-30 ht-30 rounded-circle",
                    path_image: _ctx.user?.path_image ?? `/img/icons/member.png`
                  }, null, 8, ["path_image"])
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("p", _hoisted_86, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.user?.firstName || '') + " " + _toDisplayString(_ctx.user?.lastName || ''), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("p", _hoisted_88, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.i18n.t('layout.navbar.dropdown.selecetdClub')), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.currentClub?.name ||
                  ''), 1)
                      ]),
                      _createElementVNode("p", _hoisted_89, [
                        _hoisted_90,
                        _createTextVNode(" " + _toDisplayString(_ctx.currentClub?.id), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("ul", _hoisted_91, [
                    (_ctx.hasAdminRole())
                      ? (_openBlock(), _createElementBlock("li", _hoisted_92, [
                          _createVNode(_component_router_link, {
                            to: { name: 'clubs', params: { userUUID: _ctx.userUUID } },
                            class: "bg-none text-body py-1 d-block w-100"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "shop",
                                size: "lg",
                                class: "me-2 icon-md"
                              }),
                              _createElementVNode("span", null, _toDisplayString(_ctx.i18n.t('layout.navbar.dropdown.admin_space')), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("li", {
                      class: "dropdown-item cursor-pointer border-bottom",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.switchClub()))
                    }, [
                      _createElementVNode("a", _hoisted_93, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "repeat",
                          size: "lg",
                          class: "me-2 icon-md"
                        }),
                        _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.i18n.t('layout.navbar.dropdown.switch_club')), 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_95, [
                      _createVNode(_component_router_link, {
                        to: { name: 'profile', params: { userUUID: _ctx.userUUID } },
                        class: "bg-none text-body py-1 d-block w-100"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "user-tie",
                            size: "lg",
                            class: "me-2 icon-md"
                          }),
                          _createElementVNode("span", null, _toDisplayString(_ctx.i18n.t('layout.navbar.dropdown.profile')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("li", _hoisted_96, [
                      _createVNode(_component_router_link, {
                        to: { name: 'support', params: { userUUID: _ctx.userUUID } },
                        class: "bg-none text-body py-1 d-block w-100"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "headset",
                            size: "lg",
                            class: "me-2 icon-md"
                          }),
                          _createElementVNode("span", null, _toDisplayString(_ctx.i18n.t('layout.navbar.dropdown.support')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("li", {
                      class: "dropdown-item cursor-pointer",
                      onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("a", _hoisted_97, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "sign-out-alt",
                          size: "lg",
                          class: "me-2 icon-md"
                        }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.i18n.t('layout.navbar.dropdown.logout')), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}